import { useEffect, useState } from 'react'

import { HeaderPictureFieldModel, RemoteFile } from '@types'

import { useFilePreviews } from '@hooks/file/file-preview.hook'

import { Img, ImgContainer } from './SubmitterFieldHeaderPicture.styled'

type SubmitterFieldHeaderPictureProps = {
  field: HeaderPictureFieldModel
}

export const SubmitterFieldHeaderPicture: React.FC<SubmitterFieldHeaderPictureProps> = ({
  field,
}: SubmitterFieldHeaderPictureProps) => {
  const [remoteFile, setRemoteFile] = useState<RemoteFile>()

  const { loadFilePreviews } = useFilePreviews({
    files: [field.file] as RemoteFile[],
    onFilesLoaded: ([files]) => (files ? setRemoteFile(files as RemoteFile) : undefined),
  })

  useEffect(() => {
    if (field.file) {
      loadFilePreviews()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return remoteFile ? (
    <ImgContainer>
      <Img src={remoteFile.url} crossOrigin="anonymous" />
    </ImgContainer>
  ) : (
    <></>
  )
}
